// ============================================================
// OAuthCallback.jsx — handles the OAuth redirect from backend
// Opened as a popup by AppShell/LandingPage OAuth buttons.
// Reads token from URL hash, posts it back to opener, closes.
// ============================================================
import { useEffect } from 'react';

export default function OAuthCallback() {
  useEffect(() => {
    try {
      // Data comes back in the URL hash (never in query string)
      const hash = window.location.hash.slice(1);
      if (!hash) return;

      const data = JSON.parse(decodeURIComponent(hash));

      // Post result back to the parent window (AppShell/LandingPage)
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'oauth_success', ...data },
          window.location.origin
        );
        setTimeout(() => window.close(), 300);
      } else {
        // Fallback: store in sessionStorage and redirect to app
        sessionStorage.setItem('oauth_result', JSON.stringify(data));
        window.location.href = '/';
      }
    } catch (e) {
      console.error('[OAuthCallback]', e);
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'oauth_success', error: 'parse_failed' },
          window.location.origin
        );
        setTimeout(() => window.close(), 300);
      }
    }
  }, []);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0a0f1e', flexDirection: 'column', gap: 16,
    }}>
      <div style={{ fontSize: 32 }}>🔗</div>
      <p style={{ color: '#00d4aa', fontFamily: 'sans-serif', fontSize: 14 }}>
        Connecting… this window will close automatically.
      </p>
    </div>
  );
}
